import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme from 'styled-theming';

const color = theme('mode', {
  light: (props) => props.theme.colors.darkGrey,
  dark: (props) => props.theme.colors.white,
});

const TabContainer = styled.div`
  height: 32px;
  max-width: 100%;
  justify-content: center;
  display: flex;
  cursor: pointer;
  align-items: center;
  white-space: nowrap;
  font-weight: 500;
  font-size: 14px;
  color: ${color};
  opacity: ${(props) => (props.active ? 1 : 0.4)};
  padding: 10px;
  text-decoration: ${(props) => (props.active ? 'underline' : 'none')};
  text-underline-offset: ${(props) => (props.active ? '4px' : '0px')};
  text-decoration-thickness: ${(props) => (props.active ? '3px' : 'opx')};
`;

const Tab = ({
  onClick, active, children, ...otherProps
}) => (
  <TabContainer
    active={active}
    onClick={onClick}
    {...otherProps}
  >
    {children}
  </TabContainer>
);

Tab.defaultProps = {
  active: false,
  onClick: () => { },
  children: null,
};

Tab.propTypes = {
  active: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.node,
};

export default Tab;
